import { useSelector } from "react-redux";
import { StoreState } from "../interfaces/storeState";
import { Wizard } from "../interfaces/Wizard";

export const useWizard = (): Wizard => useSelector(getWizard);

const getWizard = (state: StoreState): Wizard => state.wizard as Wizard;
